module.exports = __webpack_public_path__ + "static/media/logic_wedge4.86d34b79.png";